// extracted by mini-css-extract-plugin
export default {"links":"User_links__lHUky","logo":"User_logo__4NNm9"};